module.exports = __webpack_public_path__ + "img/33.96a25d21.jpg";